import { render, staticRenderFns } from "./RememberMeSettings.vue?vue&type=template&id=71d5a1e3&scoped=true&"
import script from "./RememberMeSettings.vue?vue&type=script&lang=ts&"
export * from "./RememberMeSettings.vue?vue&type=script&lang=ts&"
import style0 from "./RememberMeSettings.vue?vue&type=style&index=0&id=71d5a1e3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d5a1e3",
  null
  
)

export default component.exports